import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  RiLogoutBoxLine,
  RiMapPinUserFill,
} from "react-icons/ri";
const Content = ({ children, user }) => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    openNavbar: false
  })

  const showNavbar = () => {
    setState({
      openNavbar: !state.openNavbar
    })
  };
  const logout = () => {
    window.localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <div className="col-span-5">
      {/* Header */}
      <header className="flex flex-col md:flex-row gap-4 items-center justify-between p-4 md:px-8 lg:px-12 w-full">
        <form className="w-full md:w-[40%] lg:w-[30%] order-1 md:-order-none"></form>
        {/* Notifications */}
        <nav className="w-full md:w-[60%] lg:w-[70%] flex justify-center md:justify-end">
          <ul className="flex items-center gap-4">
            <li className="flex items-stretch justify-center text-gray-900">
              <section className="relative flex text-sm leading-none">
                <button
                  className="flex items-center px-3 py-2 space-x-2 mt-1 rounded-l-md focus:outline-none"
                  aria-haspopup="true"
                  onClick={showNavbar}
                >
                  <RiMapPinUserFill />
                  <span>{user.nombre} </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-10 h-4 text-gray-700"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    />
                  </svg>
                </button>
                
                {state.openNavbar ?
                <aside
                  className="absolute z-10 flex flex-col items-start w-64 mt-10 bg-white border rounded-md shadow-md"
                  role="menu"
                  x-show="open"
                  aria-labelledby="menu-heading"
                >
                  <div className="flex w-full" onClick={logout}>
                    <button
                      className="flex flex-1 w-full px-2 py-3 hover:bg-blue-600 hover:text-white focus:bg-blue-600 focus:text-white focus:outline-none"
                      type="button"
                      role="menuitem"
                    >
                      <div className="flex space-y-1 text-left word-wrap">
                        <RiLogoutBoxLine className="text-xl" />
                        <span className="px-2">Cerrar sesión</span>
                      </div>
                    </button>
                  </div>
                </aside>

                : null}


              </section>
            </li>
          </ul>
        </nav>
      </header>
      {children}
    </div>
  );
};
export default Content;
